/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import breakpoints from "assets/theme/base/breakpoints";
import { Button, TextField } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { Link } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import { Warning, Close, Delete, Person, Phone, Wc, Email, School, LocationOn, Public, LocationCity, Assignment, CalendarToday, AccessTime, SupervisorAccount, Flag, Comment } from '@mui/icons-material';
import { Chip, Divider } from '@mui/material';
import {Select, MenuItem, FormControl, InputLabel } from "@mui/material";

// Data
// import authorsTableData from "layouts/tables/data/authorsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
// import tutorTableData from "Views/people/tutor/data/tutorTableData";
// import subAdminData from "Views/people/SubAdmin/data/subAdminData";
import EhcViewTableData from "Views/Activities/Ehc/data/ehcViewTableData"
import EhcViewDiscoveryTableData from "Views/Activities/Ehc/data/ehcViewDiscoveryTableData"
import EhcViewCoordinationTableData from "Views/Activities/Ehc/data/ehcViewCoordinationTableData"

import { useState,useEffect } from "react";
import Dropdown from "components/CustomDropdown/Dropdown";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

function Tables() {


    // Dummy data
  const data = {
    parentName: "John Doe",
    mobile: "+7354722929",
    gender: "Male",
    email: "johndoe@example.com",
    tuitionMode: "Online",
    location: "New York",
    state: "NY",
    city: "New York City",
  };

     //popup
    const[deleteDialog, setDeleteDialog] = useState(false);
     
    // Delete button click handler
    const handleDeleteClick = () => {
      setDeleteDialog(true);
    };

    // Close dialog
    const handleCloseDialog = () => {
      setDeleteDialog(false);
    };
  const { columns, rows } = EhcViewTableData;
  const { columns: discoveryColumns, rows: discoveryRows } = EhcViewDiscoveryTableData;
  const { columns: coordinationColumns, rows: coordinationRows } = EhcViewCoordinationTableData;

  const cardStyle = {
  backgroundColor: "white",
  borderRadius: "10px",
  p: 2,
  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
  border: "1px solid #f5f5f5",
  height: "100%"
};

 const rows1 = [
    "Concept of Understanding",
    "Tuition Copy Maintenance",
    "Syllabus Coverage",
  ];
   const rows2 = [
    "Concepts/Chapters Clarity",
    "Time Management",
    "Presentation Skills",
    "Question Understanding",
  ];


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3}>
          
                <Card 
  sx={{ 
    borderRadius: "16px", 
    backgroundColor: "white",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    border: "1px solid #f0f0f0"
  }}
>
  <ArgonBox p={3}>
    {/* Header */}
    <ArgonBox display="flex" alignItems="center" gap={2} mb={3}>
      <ArgonBox 
        sx={{
          background: "linear-gradient(45deg, #667eea, #764ba2)",
          borderRadius: "12px",
          p: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)"
        }}
      >
        <Person sx={{ color: "white", fontSize: "22px" }} />
      </ArgonBox>

      <ArgonBox>
        <ArgonTypography variant="h6" fontWeight="medium">
          Parent Information
        </ArgonTypography>
        <ArgonTypography variant="caption" color="text.secondary">
          Complete parent and tuition details
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>

    {/* Grid Section */}
    <Grid container spacing={2}>
      {/* Parent Name */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox 
          sx={{
            backgroundColor: "white",
            borderRadius: "10px",
            p: 2,
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            border: "1px solid #f5f5f5",
            height: "100%"
          }}
        >
          <ArgonBox display="flex" alignItems="center" gap={1} mb={0}>
            <Person sx={{ color: "#667eea", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Parent Name
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography variant="caption" fontWeight="medium" color="text">{data.parentName}</ArgonTypography>
        </ArgonBox>
      </Grid>

      {/* Mobile */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1} mb={0}>
            <Phone sx={{ color: "#4ECDC4", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Mobile
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography variant="caption" color="text" fontWeight="medium">{data.mobile}</ArgonTypography>
        </ArgonBox>
      </Grid>

      {/* Gender */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
            <Wc sx={{ color: "#FF6B6B", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Gender
            </ArgonTypography>
          </ArgonBox>
          <Chip 
            label={data.gender} 
            size="small"
            sx={{ 
              bgcolor: data.gender === 'Male' ? '#E3F2FD' : '#FCE4EC', 
              color: data.gender === 'Male' ? '#1976D2' : '#C2185B',
              fontWeight: "600"
            }} 
          />
        </ArgonBox>
      </Grid>

      {/* Email */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1} mb={0}>
            <Email sx={{ color: "#45B7D1", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Email
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography 
            variant="caption" 
            color="text"
            fontWeight="medium"
            sx={{ wordBreak: "break-word" }}
          >
            {data.email}
          </ArgonTypography>
        </ArgonBox>
      </Grid>

      {/* Tuition Mode */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
            <School sx={{ color: "#96CEB4", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Tuition Mode
            </ArgonTypography>
          </ArgonBox>
          <Chip 
            label={data.tuitionMode} 
            size="small"
            sx={{ 
              bgcolor: data.tuitionMode === 'Online' ? '#E8F5E8' : '#FFF3E0', 
              color: data.tuitionMode === 'Online' ? '#2E7D32' : '#F57C00',
              fontWeight: "600"
            }} 
          />
        </ArgonBox>
      </Grid>

      {/* Location */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <LocationOn sx={{ color: "#FFEAA7", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              Location
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography variant="caption" color="text" fontWeight="medium">{data.location}</ArgonTypography>
        </ArgonBox>
      </Grid>

      {/* State */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <Public sx={{ color: "#9C27B0", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              State
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography variant="caption" color="text" fontWeight="medium">{data.state}</ArgonTypography>
        </ArgonBox>
      </Grid>

      {/* City */}
      <Grid item xs={12} sm={6} md={2}>
        <ArgonBox sx={cardStyle}>
          <ArgonBox display="flex" alignItems="center" gap={1}>
            <LocationCity sx={{ color: "#FF9800", fontSize: "18px" }} />
            <ArgonTypography variant="body2" fontWeight="medium">
              City
            </ArgonTypography>
          </ArgonBox>
          <ArgonTypography variant="caption" color="text" fontWeight="medium">{data.city}</ArgonTypography>
        </ArgonBox>
      </Grid>
    </Grid>
  </ArgonBox>
               </Card>


              
            </ArgonBox>

        <ArgonBox>
             
           <ArgonBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <ArgonTypography mb={2} variant="h6" fontWeight="medium">
        Student List
       </ArgonTypography>

      <ArgonButton
        variant="contained"
        size="small"
        color="primary"
      >
        Add
      </ArgonButton>
    </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
        </ArgonBox>

           <ArgonBox>
               <ArgonBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <ArgonTypography mb={2} variant="h6" fontWeight="medium">
        Discovery call
       </ArgonTypography>

      <ArgonButton
        variant="contained"
        size="small"
        color="primary"
      >
         Add
      </ArgonButton>
    </ArgonBox>
            


            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={discoveryColumns} rows={discoveryRows} />
            </ArgonBox>
         </ArgonBox>

          <ArgonBox mb={4}>
               <ArgonBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <ArgonTypography mb={2} variant="h6" fontWeight="medium">
        EHC Coordination
       </ArgonTypography>

      <ArgonButton
        variant="contained"
        size="small"
        color="primary"
       
      >
         Add
      </ArgonButton>
    </ArgonBox>
            

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={coordinationColumns} rows={coordinationRows} />
            </ArgonBox>
         </ArgonBox>

         <Card
        
  sx={{ 
    borderRadius: "12px", 
    backgroundColor: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    border: "1px solid #e0e0e0"
  }}
>
  <ArgonBox p={3} >
    {/* Header */}
    <ArgonBox display="flex" alignItems="center" gap={2} mb={2}>
      <ArgonBox 
        sx={{
          background: "linear-gradient(45deg, #ff956f, #F7931E)",
          borderRadius: "10px",
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(255, 107, 53, 0.25)"
        }}
      >
        <Assignment sx={{ color: "white", fontSize: "20px" }} />
      </ArgonBox>
      <ArgonBox>
        <ArgonTypography variant="h6" fontWeight="600" color="#2c3e50">
          EHC Test Form
        </ArgonTypography>
        <ArgonTypography variant="body2" color="#6c757d">
          To be filled by Study Supervisor
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>

    {/* Form */}
    <form>
      <Grid container spacing={2}>
        {/* EHC Name */}
        <Grid item xs={12}>
          <ArgonBox sx={cardStyle}>
            <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
              <Assignment sx={{ color: "#FF6B35", fontSize: "18px" }} />
              <ArgonTypography variant="body2" fontWeight="600">
                EHC Name
              </ArgonTypography>
            </ArgonBox>
            <Dropdown
              label=""
              options={["EHC Test 1", "EHC Test 2", "EHC Test 3"]}
            />
          </ArgonBox>
        </Grid>

        {/* Date and Time Section */}
        <Grid item xs={12}>
          <ArgonBox sx={cardStyle}>
            
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <CalendarToday sx={{ color: "#4ECDC4", fontSize: "18px" }} />
                  <ArgonTypography variant="body2" fontWeight="500">
                    EHC Date
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput type="date" fullWidth InputLabelProps={{ shrink: true }} />
              </Grid>

              <Grid item xs={12} md={6}>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <AccessTime sx={{ color: "#45B7D1", fontSize: "18px" }} />
                  <ArgonTypography variant="body2" fontWeight="500">
                    EHC Time
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput type="time" fullWidth InputLabelProps={{ shrink: true }} />
              </Grid>
            </Grid>
          </ArgonBox>
        </Grid>

        {/* Configuration Section */}
        <Grid item xs={12}>
          <ArgonBox sx={cardStyle}> 
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <SupervisorAccount sx={{ color: "#96CEB4", fontSize: "18px" }} />
                  <ArgonTypography variant="body2" fontWeight="500" color="#2c3e50">
                    Study Supervisor
                  </ArgonTypography>
                </ArgonBox>
                <Dropdown
                  label=""
                  options={["Dr. John Smith", "Prof. Jane Doe", "Dr. Mike Johnson"]}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <Flag sx={{ color: "#FFEAA7", fontSize: "18px" }} />
                  <ArgonTypography variant="body2" fontWeight="500" color="#2c3e50">
                    Test Status
                  </ArgonTypography>
                </ArgonBox>
                <Dropdown label="" options={["Done", "Not Done"]} />
              </Grid>

              <Grid item xs={12} md={4}>
                <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                  <ArgonTypography variant="body2" fontWeight="500" color="#2c3e50">
                    Remarks
                  </ArgonTypography>
                </ArgonBox>
                <ArgonInput
                  placeholder="Enter remarks..."
                  fullWidth
                  multiline
                  rows={2}
                />
              </Grid>
            </Grid>
          </ArgonBox>
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12}>
          <ArgonBox display="flex" justifyContent="center" mt={2}>
            <ArgonButton
              variant="contained"
              color="primary"
            >
              Submit EHC Test
            </ArgonButton>
          </ArgonBox>
        </Grid>
      </Grid>
    </form>
  </ArgonBox>
       </Card>

       <ArgonBox p={2}  sx={{ 
    borderRadius: "12px", 
    backgroundColor: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    border: "1px solid #e0e0e0"
  }}>
        <ArgonTypography variant="h6">EHC Report</ArgonTypography>


     <ArgonBox display="flex" gap={2} p={3}>
        <Dropdown
          label=""
          options={["Select Student"]}
        />
        <Dropdown
          label=""
          options={["Select Student"]}
        />
     </ArgonBox>

      <Card
      sx={{
        borderRadius: "10px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
      }}
    >
      {/* Header */}
      <ArgonBox
        sx={{ backgroundColor: "#d6d6d6", py: 1, px: 2 }}
      >
        <ArgonTypography
          align="center"
          fontWeight="medium"
          sx={{ color: "#2c3e50" }}
        >
          A. General Overview
        </ArgonTypography>
      </ArgonBox>

      {/* Table Headings */}
      <ArgonBox px={2} py={2}>
        <Grid container spacing={2} sx={{ mb: 1 }}>
          <Grid item xs={4}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              {/* empty cell for alignment */}
            </ArgonTypography>
          </Grid>
          <Grid item xs={2}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Marks
            </ArgonTypography>
          </Grid>
          <Grid item xs={2}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Total
            </ArgonTypography>
          </Grid>
          <Grid item xs={4}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Remark
            </ArgonTypography>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />

        {/* Table Rows */}
        {rows1.map((label, idx) => (
          <Grid container spacing={2} alignItems="center" key={idx} sx={{ mb: 2 }}>
            <Grid item xs={4}>
              <ArgonTypography
                variant="body2"
                fontWeight="medium"
              >
                {label}
              </ArgonTypography>
            </Grid>
            <Grid item xs={2}>
              <ArgonInput placeholder="Enter Marks" size="small" fullWidth />
            </Grid>
            <Grid item xs={2}>
              <ArgonInput placeholder="Enter Total" size="small" fullWidth />
            </Grid>
            <Grid item xs={4}>
              <ArgonInput
                placeholder="Enter Remark"
                size="small"
                fullWidth
                multiline
                rows={1}
              />
            </Grid>
          </Grid>
        ))}
      </ArgonBox>
    </Card>
       

       </ArgonBox>

         <ArgonBox p={2}  sx={{ 
    borderRadius: "12px", 
    backgroundColor: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    border: "1px solid #e0e0e0"
  }}>
    

      <Card
      sx={{
        borderRadius: "10px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
      }}
    >
      {/* Header */}
      <ArgonBox
        sx={{ backgroundColor: "#d6d6d6", py: 1, px: 2 }}
      >
        <ArgonTypography
          align="center"
          fontWeight="medium"
          
        >
          B. AnswerSheet Analysis
        </ArgonTypography>
      </ArgonBox>

      {/* Table Headings */}
      <ArgonBox px={2} py={2}>
        <Grid container spacing={2} sx={{ mb: 1 }}>
          <Grid item xs={4}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              {/* empty cell for alignment */}
            </ArgonTypography>
          </Grid>
          <Grid item xs={2}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Marks
            </ArgonTypography>
          </Grid>
          <Grid item xs={2}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Total
            </ArgonTypography>
          </Grid>
          <Grid item xs={4}>
            <ArgonTypography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
            >
              Remark
            </ArgonTypography>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />

        {/* Table Rows */}
        {rows2.map((label, idx) => (
          <Grid container spacing={2} alignItems="center" key={idx} sx={{ mb: 2 }}>
            <Grid item xs={4}>
              <ArgonTypography
                variant="body2"
                fontWeight="medium"
              >
                {label}
              </ArgonTypography>
            </Grid>
            <Grid item xs={2}>
              <ArgonInput placeholder="Enter Marks" size="small" fullWidth />
            </Grid>
            <Grid item xs={2}>
              <ArgonInput placeholder="Enter Total" size="small" fullWidth />
            </Grid>
            <Grid item xs={4}>
              <ArgonInput
                placeholder="Enter Remark"
                size="small"
                fullWidth
                multiline
                rows={1}
              />
            </Grid>
          </Grid>
        ))}
      </ArgonBox>
    </Card>
       

       </ArgonBox>

            
          </Card>
          
        </ArgonBox>

        
        

      </ArgonBox>
      

          {/* dialog popup */}

    <Dialog 
      open={deleteDialog} 
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          overflow: 'visible'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1, position: 'relative' }}>
        <ArgonBox display="flex" alignItems="center" gap={2}>
          <ArgonBox 
            sx={{
              background: 'linear-gradient(45deg, #ff6b6b, #ee5a52)',
              borderRadius: '12px',
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 25px rgba(255, 107, 107, 0.3)'
            }}
          >
            <Warning sx={{ color: 'white', fontSize: '24px' }} />
          </ArgonBox>
          <ArgonBox>
            <ArgonTypography variant="h5" fontWeight="bold">
              Delete Sub-Admin
            </ArgonTypography>
            <ArgonTypography variant="body2" color="#6c757d">
              This action requires confirmation
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
        <IconButton
          onClick={handleCloseDialog}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#6c757d',
            '&:hover': {
              backgroundColor: '#f8f9fa',
              color: '#dc3545'
            }
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ py: 3 }}>
        <ArgonBox 
          sx={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '8px',
            p: 2.5,
            mb: 2
          }}
        >
          <ArgonTypography variant="body1" color="#856404" fontWeight="medium">
            Are you sure you want to delete this Sub Admin?
          </ArgonTypography>
          <ArgonTypography variant="body2" color="#856404" mt={1}>
            This action cannot be undone and will permanently remove all tutor data.
          </ArgonTypography>
        </ArgonBox>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, pt: 0, gap: 2 }}>
        <Button 
          onClick={handleCloseDialog} 
          variant="outlined"
          sx={{
            borderColor: '#6c757d',
            color: '#6c757d',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '600',
            px: 3,
            '&:hover': {
              borderColor: '#495057',
              color: '#495057',
              backgroundColor: '#f8f9fa'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleCloseDialog} 
          variant="contained"
          startIcon={<Delete />}
          sx={{
            background: 'linear-gradient(45deg, #dc3545, #c82333)',
            color: 'white',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '600',
            px: 3,
            boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)',
            '&:hover': {
              background: 'linear-gradient(45deg, #c82333, #a71e2a)',
              boxShadow: '0 6px 20px rgba(220, 53, 69, 0.4)',
              transform: 'translateY(-1px)'
            },
            transition: 'all 0.2s ease',
            color:"white !important"
          }}
        >
          Delete Sub-Admin
        </Button>
      </DialogActions>
    </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
